import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { RouterModule } from "@angular/router";
import { AddUserModalComponent } from "./add_user_modal.component";
import { AssessmentAssignmentFormComponent } from "./assessment_assignment_form.component";
import { UserAssignmentModalComponent } from "./user_assignment_modal.component";

@NgModule({
    declarations: [AddUserModalComponent, AssessmentAssignmentFormComponent, UserAssignmentModalComponent],
    imports: [CommonModule, ReactiveFormsModule, NzButtonModule, NzInputModule, NzSelectModule, NzModalModule, NzIconModule, NzToolTipModule, RouterModule],
    exports: [AddUserModalComponent, AssessmentAssignmentFormComponent, UserAssignmentModalComponent]
})
export class AddUserModalModule {}
